import { render, staticRenderFns } from "./TxDragRow.vue?vue&type=template&id=5549967a&scoped=true&lang=pug&"
import script from "./TxDragRow.vue?vue&type=script&lang=ts&"
export * from "./TxDragRow.vue?vue&type=script&lang=ts&"
import style0 from "./TxDragRow.vue?vue&type=style&index=0&id=5549967a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549967a",
  null
  
)

component.options.__file = "TxDragRow.vue"
export default component.exports